module.exports = __webpack_public_path__ + "static/media/normal.5ceb6e7c.svg";